import { Component, HostListener, ViewChild } from '@angular/core';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { ConfigurationSaisieDonneesAnalyse, ModeSaisie } from '../../bo/configurationSaisieDonneesAnalyse';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { TraductionService } from '../../services/traduction.service';
import { AccessPermissionType } from 'src/app/bo/accessPermisionType';

@Component({
  selector: 'app-config-donnees-analyse-modale',
  templateUrl: './config-donnees-analyse-modale.component.html',
  styleUrls: ['./config-donnees-analyse-modale.component.scss'],
  standalone: false
})

export class ConfigDonneesAnalyseModaleComponent {
  @ViewChild('modalConfirmCancel') modalConfirmCancel: ModalDirective;
  config: ConfigurationSaisieDonneesAnalyse;
  success: boolean;
  configSauv: ConfigurationSaisieDonneesAnalyse;
  annul = false;
  erreurApi: boolean;
  erreurValeurNominal: boolean;
  valeursNonCoherentes: boolean;
  valeurMinVide: boolean;
  valeurMaxVide: boolean;
  valeurNomVide: boolean;
  tabModeSaisieProjet: any;
  txtModeSaisieDonneeProjet: any;
  accessPermission:AccessPermissionType = AccessPermissionType.READ;
  accessPermissionArray:string[] = ['ACCESS_PERMISSION.NONE', 'ACCESS_PERMISSION.READ', 'ACCESS_PERMISSION.READWRITE'];
  isAccessPermissionDisabled:boolean;

  constructor(private readonly http: HttpService, private readonly bsModalRef: BsModalRef, private readonly fonctionsService: FonctionsService, private readonly traductionService: TraductionService) {
    //Tableau de correspondance text => valeur dans mode de saisie des KPI projets (traduit)
    this.traductionService.translate.get(['GLOBAL.MOYENNE', 'GLOBAL.SOMME', 'GLOBAL.MINIMUM', 'GLOBAL.MAXIMUM', 'GLOBAL.MANUELLE']).subscribe(traduction => {
      this.tabModeSaisieProjet = [
        { nom: traduction['GLOBAL.MANUELLE'], val: ModeSaisie.Manuelle },
        { nom: traduction['GLOBAL.SOMME'], val: ModeSaisie.Somme },
        { nom: traduction['GLOBAL.MOYENNE'], val: ModeSaisie.Moyenne },
        { nom: traduction['GLOBAL.MINIMUM'], val: ModeSaisie.Min },
        { nom: traduction['GLOBAL.MAXIMUM'], val: ModeSaisie.Max }];
    });
  }

  ngOnInit() {
    if (this.config) {
      this.isAccessPermissionDisabled = !this.config.isEnabled;
      var t = this.tabModeSaisieProjet.filter(p => p.val == this.config.modeSaisieDonneeProjet);
      this.txtModeSaisieDonneeProjet = t[0].nom;
      this.configSauv = JSON.parse(JSON.stringify(this.config));
    }
  }

  @HostListener('window:keydown.esc', ['$event'])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
    }
    this.showModalCancel();
  }

  onSubmit() {
    if (this.validationFormulaire()) {
      this.fonctionsService.loading_screen(true);
      this.erreurApi = false;
      // Les méthodes POST/PUT prennent une liste de configuration en entrée
      let tabConfig: ConfigurationSaisieDonneesAnalyse[] = [];
      tabConfig.push(this.config);
      let requete = this.config.configurationSaisieDonneesAnalyseId != 0 ? this.http.put<ConfigurationSaisieDonneesAnalyse[], ConfigurationSaisieDonneesAnalyse[]>('ConfigAnalysisEntry', tabConfig)
        : this.http.post<ConfigurationSaisieDonneesAnalyse[], ConfigurationSaisieDonneesAnalyse[]>('ConfigAnalysisEntry', tabConfig);

      requete.subscribe(resultat => {
        if (resultat) {
          this.config = resultat[0];
          this.config.referentielDonneeAnalyse = this.configSauv.referentielDonneeAnalyse;
          this.config.txtModeSaisieDonneeProjet = this.txtModeSaisieDonneeProjet;
          this.success = true;
        }
        else
          this.erreurApi = true;

        this.fonctionsService.loading_screen(false);
        if (!this.erreurApi) {
          this.fonctionsService.launch_toast(this.success);
          this.bsModalRef.hide();
        }
      }, () => {
        this.erreurApi = true;
        this.fonctionsService.loading_screen(false);
      });
    }
  }

  validationFormulaire() {
    this.erreurValeurNominal = false;
    this.valeursNonCoherentes = false;
    if (this.config.referentielDonneeAnalyse.nomTypeReferentiel == 'number') {

      if (this.config.valeurNominal) {
        if (this.config.valeurMin)
          this.erreurValeurNominal = this.config.valeurNominal < this.config.valeurMin
        if (this.config.valeurMax)
          this.erreurValeurNominal = this.config.valeurNominal > this.config.valeurMax;
      }
      if (this.config.valeurMax && this.config.valeurMin)
        this.valeursNonCoherentes = this.config.valeurMin > this.config.valeurMax;

      return !this.erreurValeurNominal && !this.valeursNonCoherentes;
    } else
      return true
  }

  onChangeModeSaisie(item: any) {
    this.txtModeSaisieDonneeProjet = item.nom;
  }

  showModalCancel() {
    if (this.diff()) {
      this.modalConfirmCancel.show();
    } else {
      this.annulModif();
    }
  }

  diff() {
    return this.config.isEnabled !== this.configSauv.isEnabled;
  }


  annulModif() {
    this.annul = true;
    this.bsModalRef.hide();
  }

  protected checkIsEnabled(){
    if(!this.config.isEnabled){
        this.config.accessPermission = 0;
        this.isAccessPermissionDisabled = true;
    }else{
      this.isAccessPermissionDisabled = false;
    }
  }

  protected valeurNominalCheck(){
     if(this.config.valeurNominal >  this.config.valeurMax){
      this.config.valeurNominal = this.config.valeurMax;
     }else if(this.config.valeurNominal <  this.config.valeurMin){
      this.config.valeurNominal = this.config.valeurMin;
     }
  }


}
